import React, { Component } from 'react'
import {Helmet} from 'react-helmet'

import NavBar from '../../components/NavBar';
import PastCompetitionData from '../../components/PastCompetitionData';

import { Container, Row, Col, Image } from 'react-bootstrap';

export default class PastCompetition2016 extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | The 2016 Competition</title>
                </Helmet>
                <NavBar hasHero={false} />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h1>The 2016 Competition</h1>
                        </Col>
                    </Row>
                    <PastCompetitionData teams="4" physicsTopic="Water Rocket" winner="SSIS" />
                    <br />
                    <Row>
                        <Col lg="4 auto">
                            <Image alt="Water Rocket" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fwater_rocket.jpeg?alt=media&token=bea1c0da-2fb7-4438-a893-8ab549928f00" rounded fluid />
                        </Col>
                        <Col>
                            <p>In 2016, Kyu Hwan Choi and a group of passionate students hosted the first International School Science Competition. Four different international schools from across Ho Chi Minh city participated, each with one team. The schools included Saigon South International School, Renaissance International School Saigon, Korean International School, and Anglophone British Curriculum International School.</p>
                            <p>The competition had one topic: Water Rocket. The expectations were to have the rocket fly tallest height, measured by a computer program. A presentation was also required to lead the audience through the research process, the mechanism and the procedure. Each team had six months of preparation including the summer between two school years.</p>
                        </Col>
                    </Row>
                </Container>
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}
